import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  id: "AlbumDetail"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$albumDetail$deta, _ctx$albumDetail$deta2, _ctx$albumDetail$deta3, _ctx$albumDetail$comm, _ctx$albumDetail$deta4, _ctx$albumDetail$deta5;

  var _component_ListDetailTop = _resolveComponent("ListDetailTop");

  var _component_ListDetailNav = _resolveComponent("ListDetailNav");

  var _component_ListDetail = _resolveComponent("ListDetail");

  var _component_Comment = _resolveComponent("Comment");

  var _component_AlbumDesc = _resolveComponent("AlbumDesc");

  var _component_Loading = _resolveComponent("Loading");

  return _ctx.route.params.id == ((_ctx$albumDetail$deta = _ctx.albumDetail.detail) === null || _ctx$albumDetail$deta === void 0 ? void 0 : (_ctx$albumDetail$deta2 = _ctx$albumDetail$deta.album) === null || _ctx$albumDetail$deta2 === void 0 ? void 0 : _ctx$albumDetail$deta2.id) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 头部详情区域 "), _createVNode(_component_ListDetailTop, {
    detailTopInfo: (_ctx$albumDetail$deta3 = _ctx.albumDetail.detail) === null || _ctx$albumDetail$deta3 === void 0 ? void 0 : _ctx$albumDetail$deta3.album,
    detailType: "专辑"
  }, null, 8
  /* PROPS */
  , ["detailTopInfo"]), _createCommentVNode(" 专辑导航 "), _createVNode(_component_ListDetailNav, {
    navList: _ctx.navList,
    commentTotal: (_ctx$albumDetail$comm = _ctx.albumDetail.comments) === null || _ctx$albumDetail$comm === void 0 ? void 0 : _ctx$albumDetail$comm.total,
    onTitleClick: _ctx.titleClick
  }, null, 8
  /* PROPS */
  , ["navList", "commentTotal", "onTitleClick"]), _createCommentVNode(" 歌曲列表 "), _ctx.isShow == 0 ? (_openBlock(), _createBlock(_component_ListDetail, {
    key: 0,
    musicList: (_ctx$albumDetail$deta4 = _ctx.albumDetail.detail) === null || _ctx$albumDetail$deta4 === void 0 ? void 0 : _ctx$albumDetail$deta4.songs
  }, null, 8
  /* PROPS */
  , ["musicList"])) : _ctx.isShow == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" 评论页面 "), _createVNode(_component_Comment, {
    commentInfo: _ctx.albumDetail.comments,
    pageInfo: _ctx.alumCmtResData,
    onChangeCurrent: _ctx.changeCurrent
  }, null, 8
  /* PROPS */
  , ["commentInfo", "pageInfo", "onChangeCurrent"])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  )) : _ctx.isShow == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createCommentVNode(" 歌手描述 "), _createVNode(_component_AlbumDesc, {
    description: (_ctx$albumDetail$deta5 = _ctx.albumDetail.detail) === null || _ctx$albumDetail$deta5 === void 0 ? void 0 : _ctx$albumDetail$deta5.album.description
  }, null, 8
  /* PROPS */
  , ["description"])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  )) : (_openBlock(), _createBlock(_component_Loading, {
    key: 3
  }))])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1
  }));
}